import React from 'react';
import { Link } from 'react-router-dom';
import '../css/Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="legal-links">
        <Link to="/agb" className="legal-link">AGB</Link>
        <Link to="/datenschutzapp" className="legal-link">Datenschutz App</Link>
        <Link to="/datenschutz" className="legal-link">Datenschutz Webseite</Link>
        <Link to="/impressum" className="legal-link">Impressum</Link>
        <Link to="/kontakt" className="legal-link">Kontakt</Link>
      </div>
      <div className="copyright">
        &copy; {new Date().getFullYear()} DIPF
      </div>
    </footer>
  );
}

export default Footer;